module.exports = __webpack_public_path__ + "img/sizefound_animation_loop.gif";